import { FC, useEffect, useState } from "react";
import LogoutIcon from '@mui/icons-material/Logout';
import { Box, Tooltip } from "@mui/material";
import UgskLogo from "shared/assets/UgskLogo";

import styles from 'shared/app-drawer/Header.module.css';
import { useNavigate } from "react-router-dom";
import { fetchClearAllCookies } from "shared/utils/clear-all-cookies";
import { AlertMessage } from "shared/alert-message/alert-message";
import appStyles from 'app/providers/theme/App.module.css';

interface IAlertInfo {
    message?: string;
    severity?: string;
}


export const Header: FC = () => {
    const [alertInfo, setAlertInfo] = useState<IAlertInfo>({ message: '', severity: '' });
    const navigate = useNavigate();
    const handleLogout = () => {
        fetchClearAllCookies().then((e) => {
            if (e) {
                navigate('/auth');
            } else {
                setAlertInfo({ message: 'Что-то пошло не так. Пожалуйста, попробуйте повторить запрос позже.', severity: 'error' });
            }
        })
        navigate('/auth');
    }

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setAlertInfo({ message: '', severity: '' });
        }, 3000);
        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <>
            {alertInfo.message && (
                <Box className={appStyles.alertBox}>
                    <AlertMessage alertInfo={alertInfo} />
                </Box>
            )}
            <Box className={styles.headerBox}>
                <Box className={styles.border}>
                    <Tooltip title={process.env.APP_VERSION} placement="top">
                        <UgskLogo />
                    </Tooltip>
                    <span className={styles.logoutIcon} onClick={handleLogout}>
                        Выйти <LogoutIcon />
                    </span>

                </Box>

            </Box>
        </>

    )
};